import { render, staticRenderFns } from "./CustomerFooterBar.vue?vue&type=template&id=31fa1f96&scoped=true&"
import script from "./CustomerFooterBar.vue?vue&type=script&lang=js&"
export * from "./CustomerFooterBar.vue?vue&type=script&lang=js&"
import style0 from "./CustomerFooterBar.vue?vue&type=style&index=0&id=31fa1f96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fa1f96",
  null
  
)

export default component.exports